import { handleResponse } from "utils/utils";
import { authService } from "services";

export const expenseGroupingsService = {
    getAll,
    getById,
    add,
    update,
    remove,
};

// get expense groupings
function getAll(options) {
    const requestOptions = {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${authService.token.access_token}`
        },
    };

    let query = '?sort=+name';

    if (options) {
        let { q } = options;

        if (q !== undefined)
            query += "&q=" + q;
    }

    return fetch(`${global.BASE_API}expense-groupings${query}`, requestOptions).then(handleResponse);
}

// get expense grouping by id
function getById(id) {
    const requestOptions = {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${authService.token.access_token}`
        },
    };

    return fetch(`${global.BASE_API}expense-groupings/${id}`, requestOptions).then(handleResponse);
}

// add new expense grouping
function add(grouping) {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${authService.token.access_token}`,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(grouping)
    };

    return fetch(`${global.BASE_API}expense-groupings/`, requestOptions).then(handleResponse);
}

// update expense grouping
function update(grouping) {
    const requestOptions = {
        method: 'PUT',
        headers: {
            'Authorization': `Bearer ${authService.token.access_token}`,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(grouping)
    };

    return fetch(`${global.BASE_API}expense-groupings/${grouping.id}`, requestOptions).then(handleResponse);
}

// remove expense grouping
function remove(id) {
    const requestOptions = {
        method: 'DELETE',
        headers: {
            'Authorization': `Bearer ${authService.token.access_token}`
        },
    };

    return fetch(`${global.BASE_API}expense-groupings/${id}`, requestOptions).then(handleResponse);
}
